import script from "./ToastNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastNotifications.vue?vue&type=script&setup=true&lang=js"

import "./ToastNotifications.vue?vue&type=style&index=0&id=76f1417a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f1417a"]])

export default __exports__